const fetchReleaseUseCase = (repository) => async (pagination, filter) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        ...filter
    }
    return await repository(payload);
}

export default fetchReleaseUseCase;